import * as XLSX from 'xlsx';

(() => {
  angular
    .module('app')
    .controller(
      'common.views.patientTickets.importExcelManualTicket',
      ImportExcelManualTicketController
    );

  ImportExcelManualTicketController.$inject = [
    '$scope',
    '$uibModalInstance',
    'abp.services.app.patientTicket',
    'abp.services.app.employee',
    'abp.services.app.commonLookup',
  ];

  function ImportExcelManualTicketController(
    $scope,
    $uibModalInstance,
    patientTicketSvc,
    employeeSvc,
    commonLookupSvc
  ) {
    const vm = this;

    vm.loading = 0;
    vm.pageState = 0;
    vm.result = null;
    vm.tickets = '';
    vm.ticketData = null;
    vm.nationalIds = [];
    vm.employees = [];
    vm.validationErrors = [];
    vm.processedCount = 0;
    vm.successCount = 0;
    vm.errorCount = 0;
    vm.countryCode = null;
    vm.downloadingTemplate = 0;
    vm.successMessage = '';
    vm.currencyCode = '';

    // Track if workbook is open

    $scope.isWorkbookOpen = false;

    vm.back = back;
    vm.close = close;
    vm.processTickets = processTickets;
    vm.sheet = sheet;
    vm.downloadTemplate = downloadTemplate;

    init();

    function init() {
      getTenantCountryCode();
      getCurrencyCode();
    }

    function getTenantCountryCode() {
      vm.loading += 1;
      commonLookupSvc
        .getTenantCountryCode()
        .success((data) => {
          vm.countryCode = data;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function back() {
      vm.pageState = 0;
      vm.result = null;
      vm.tickets = [];
      vm.nationalIds = [];
      vm.validationErrors = [];
      vm.processedCount = 0;
      vm.successCount = 0;
      vm.errorCount = 0;
      vm.successMessage = '';

      // Clear the workbook if going back

      if ($scope.isWorkbookOpen) {
        $scope.isWorkbookOpen = false;
      }
    }

    function close() {
      $uibModalInstance.close();
    }

    function sheet(workbooks) {
      try {
        // Get the second sheet

        const firstSheetName = workbooks.SheetNames[1];
        const worksheet = workbooks.Sheets[firstSheetName];

        // Convert sheet to JSON with headers

        const data = XLSX.utils.sheet_to_json(worksheet, {
          raw: false,
          header: 1,
          dateNF: 'dd/mm/yyyy',
        });

        // Clear previous data

        vm.tickets = [];
        vm.unprocessedTickets = [];
        vm.validationErrors = [];

        // Skip header row (index 0) and process data rows

        for (let i = 1; i < data.length; i += 1) {
          const row = data[i];

          // Skip empty rows

          if (!row || row.length === 0) {
            // Skip processing for empty rows
          } else {
            const ticket = parseTicketFromRow(row, i + 1);

            if (ticket) {
              vm.unprocessedTickets.push(ticket);
            }
          }
        }

        vm.ticketData = buildTicketData(vm.unprocessedTickets);

        // Set workbook as open and move to results page

        $scope.isWorkbookOpen = true;
        vm.pageState = 1;

        // Trigger digest cycle to update UI

        $scope.$apply();
      } catch (error) {
        abp.notify.error(App.localize('ErrorProcessingExcelFile'));
        $scope.$apply();
      }
    }

    function parseTicketFromRow(row, rowNumber) {
      const ticket = {
        rowNumber,
        employeeIC: row[0] ? row[0].toString().trim() : '',
        principalIC: row[1] ? row[1].toString().trim() : null,
        serviceType: row[2] ? row[2].toString().trim() : '',
        ticketDate: row[3] ? row[3].toString().trim() : '',
        panelName: row[4] ? row[4].toString().trim() : '',
        panelAddress: row[5] ? row[5].toString().trim() : '',
        doctorName: row[6] ? row[6].toString().trim() : '',
        treatmentRemark: row[7] ? row[7].toString().trim() : '',
        treatmentAmount: row[8] ? parseFloat(row[8].toString().replace(',', '')) : null,
        mcRequired: row[9] ? row[9].toString().trim().toUpperCase() : 'NO',
        mcDays: row[10] ? parseFloat(row[10]) : null,
        mcRemark: row[11] ? row[11].toString().trim() : '',
      };

      vm.nationalIds.push(ticket.employeeIC);

      ticket.employeeType = ticket.principalIC
        ? App.localize('Dependent')
        : App.localize('Principal');

      // Validate the ticket

      const validation = validateTicket(ticket);

      if (validation.isValid) {
        return ticket;
      }

      vm.validationErrors.push({
        row: rowNumber,
        errors: validation.errors,
      });
      return null;
    }

    function validateTicket(ticket) {
      const errors = [];

      // Required field validations

      if (!ticket.employeeIC) {
        errors.push(App.localize('IdentificationNumberRequired'));
      }

      if (!ticket.serviceType) {
        errors.push(App.localize('ServiceTypeRequired'));
      }

      if (!ticket.ticketDate) {
        errors.push(App.localize('TicketDateRequired'));
      } else if (Number.isNaN(Date.parse(ticket.ticketDate))) {
        errors.push(App.localize('InvalidDate'));
      }

      if (!ticket.panelName) {
        errors.push(App.localize('PanelNameRequired'));
      }

      if (!ticket.panelAddress) {
        errors.push(App.localize('PanelAddressRequired'));
      }

      if (!ticket.doctorName) {
        errors.push(App.localize('DoctorNameRequired'));
      }

      if (!ticket.treatmentRemark) {
        errors.push(App.localize('TreatmentRemarkRequired'));
      }

      if (ticket.treatmentAmount === null || ticket.treatmentAmount <= 0) {
        errors.push(App.localize('TreatmentAmountGreaterThanZero'));
      }

      // MC validations
      if (ticket.mcRequired === 'YES') {
        if (!ticket.mcDays || ticket.mcDays <= 0) {
          errors.push(App.localize('MCDaysGreaterThanZero'));
        }
        if (!ticket.mcRemark) {
          errors.push(App.localize('MCRemarkRequired'));
        }
      }
      return {
        isValid: errors.length === 0,
        errors,
      };
    }

    function processTickets() {
      if (vm.ticketData.length === 0) {
        abp.notify.warn(App.localize('NoValidTicketsFoundToProcess'));
        return;
      }

      vm.loading = 1;
      vm.processedCount = 0;

      BulkCreateTickets();
    }

    function buildTicketData(tickets) {
      vm.loading += 1;
      const ticketDataList = [];

      employeeSvc
        .getEmployees({ nationalIds: vm.nationalIds })
        .success((data) => {
          vm.employees = data.items;

          tickets.forEach((ticket) => {
            const isPrincipal =
              (ticket.employeeIC && !ticket.principalIC) ||
              (ticket.principalIC && ticket.employeeIC === ticket.principalIC);

            const employee = vm.employees.find(
              (e) => e.nationalId === ticket.employeeIC && e.employeeType === (isPrincipal ? 0 : 1)
            );

            if (!employee) {
              const errorMessage = App.localize(
                'EmployeeNotFoundForIdentificationNumber',
                ticket.employeeIC
              );
              vm.validationErrors.push({
                row: ticket.rowNumber,
                errors: [errorMessage],
              });

              return; // Skip this ticket if employee not found
            }

            vm.tickets.push(ticket);

            // Map ticket for BulkCreateTicket submission

            const ticketData = {
              employeeId: employee.id,
              serviceTypeName: ticket.serviceType,
              ticketDate: ticket.ticketDate,
              manualClinicName: ticket.panelName,
              manualClinicLocation: ticket.panelAddress,
              manualDoctorName: ticket.doctorName,
              treatmentRemark: ticket.treatmentRemark,
              manualPayment: ticket.treatmentAmount,
            };

            // Add medical certificate if required
            if (ticket.mcRequired === 'YES') {
              ticketData.mcDays = ticket.mcDays;
              ticketData.mcRemark = ticket.mcRemark;
            }

            ticketDataList.push(ticketData);
          });
        })
        .error((error) => {
          abp.notify.error(
            App.localize('FailedToProcessTickets', error.message || 'Unknown error')
          );
        })
        .finally(() => {
          vm.loading -= 1;
        });

      return {
        tickets: ticketDataList,
      };
    }

    function BulkCreateTickets() {
      patientTicketSvc
        .bulkCreateTickets(vm.ticketData)
        .success((data) => {
          vm.successMessage = data.message;
          abp.notify.success(App.localize('TicketsProcessedSuccessfully'));
        })
        .error((error) => {
          abp.notify.error(
            App.localize('FailedToProcessTickets', error.message || 'Unknown error')
          );
        })
        .finally(() => {
          vm.pageState = 2;
          vm.loading = 0;
        });
    }

    function downloadTemplate() {
      vm.downloadingTemplate = 1;
      patientTicketSvc
        .getBatchManualTicketTemplate()
        .success((response) => {
          abp.notify.success(App.localize('TemplateDownloadedSuccessfully'));
          App.downloadTempFile(response);
        })
        .error((error) => {
          abp.notify.error(
            App.localize('FailedToDownloadTemplate', error.message || 'Unknown error')
          );
        })
        .finally(() => {
          vm.downloadingTemplate = 0;
        });
    }

    function getCurrencyCode() {
      vm.loading += 1;
      commonLookupSvc
        .getTenantCurrencyCode()
        .success((currencyCode) => {
          vm.currencyCode = currencyCode;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }
  }
})();
